import apiService from '@/services/apiService';

const actions = {
  getAbouts({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('about-us')
        .then((response) => {
          commit('getAbouts', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getAbout({ commit }, payload) {
    apiService.get(`about-us/${payload}`)
      .then((response) => {
        commit('getAbout', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  orderAbout({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`about-us/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postAbout({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('about-us', payload)
        .then((response) => {
          commit('postAbout', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putAbout({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`about-us/${payload.id}`, payload.formData)
        .then((response) => {
          commit('putAbout', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delAbout({ commit }, payload) {
    apiService.delete(`about-us/${payload}`)
      .then((response) => {
        commit('delAbout', payload);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

};

export default actions;
